export default __webpack_public_path__ + "static/media/undraw_augmented.7d527fbb.svg";